const { InspectorControls } = wp.blockEditor;
const { PanelBody, ToggleControl, RangeControl, SelectControl, PanelRow } =
  wp.components;

import CommonPanel from '../wp-controlers/common-panel';

const Inspector = ({ attributes, setAttributes }) => {
  const { containerized, thead, tfoot, lines, columns, content, variant } =
    attributes;

  //Altera a quantidade de linhas do objeto com o conteudo da tabela
  const changeLine = (val) => {
    let newContent = [];
    const currentSize = content.length;

    if (val > currentSize) {
      newContent = content;

      for (let index = currentSize; index < val; index++) {
        newContent.push({
          columns: Array(columns),
        });
      }
    } else {
      newContent = content.slice(0, val);
    }

    setAttributes({ lines: val, content: newContent });
  };

  //Altera a quantidade de colunas do objeto com o conteudo da tabela
  const changeColumns = (val) => {
    let newContent = content.map((line) => {
      const currentColSize = line.columns.length;
      let newColumns = [];

      if (val > currentColSize) {
        newColumns = line.columns;

        for (let index = currentColSize; index < val; index++) {
          newColumns.push('');
        }
      } else {
        newColumns = line.columns.slice(0, val);
      }

      line.columns = newColumns;

      return line;
    });

    setAttributes({ columns: val, content: newContent });
  };

  return (
    <InspectorControls>
      <PanelBody>
        <ToggleControl
          label="A tabela está fora de um container?"
          checked={containerized}
          onChange={() => setAttributes({ containerized: !containerized })}
        />

        <PanelRow className="panel-row-double-col">
          <ToggleControl
            label="Cabeçalho:"
            checked={thead}
            onChange={() => setAttributes({ thead: !thead })}
          />

          <ToggleControl
            label="Rodapé:"
            checked={tfoot}
            onChange={() => setAttributes({ tfoot: !tfoot })}
          />
        </PanelRow>

        <RangeControl
          label="Quantidade de linhas"
          initialPosition={lines}
          value={lines}
          onChange={(value) => changeLine(value)}
          min={1}
          max={50}
        />

        <RangeControl
          label="Quantidade de colunas"
          initialPosition={columns}
          value={columns}
          onChange={(value) => changeColumns(value)}
          min={1}
          max={5}
        />

        <SelectControl
          label="Selecione o estilo desejado"
          title="Selecione o estilo desejado"
          value={variant}
          options={[
            { label: 'Padrão', value: 'default' },
            { label: 'Linha cinza e azul ', value: 'tableGreyBlue' },
            { label: 'Linha cinza e azul claro', value: 'tableGreyBlueLight' },
          ]}
          onChange={(position) => setAttributes({ variant: position })}
        />
      </PanelBody>

      <CommonPanel attributes={attributes} setAttributes={setAttributes} />
    </InspectorControls>
  );
};

export default Inspector;
